import { create } from 'zustand';
import { SenderFilter } from '../types/sender.types';

interface SendersState {
  // Filters
  searchQuery: string;
  statusFilter: SenderFilter;

  // UI State
  selectedSenderUuid: string | null;
  isCreateModalOpen: boolean;
  isEditModalOpen: boolean;
  isValidationModalOpen: boolean;
  isConfigurationModalOpen: boolean;
  isDeleteModalOpen: boolean;

  // Actions
  setSearchQuery: (query: string) => void;
  setStatusFilter: (filter: SenderFilter) => void;
  setSelectedSender: (uuid: string | null) => void;
  openCreateModal: () => void;
  closeCreateModal: () => void;
  openEditModal: (uuid: string) => void;
  closeEditModal: () => void;
  openValidationModal: (uuid: string) => void;
  closeValidationModal: () => void;
  openConfigurationModal: (uuid: string) => void;
  closeConfigurationModal: () => void;
  openDeleteModal: (uuid: string) => void;
  closeDeleteModal: () => void;
  resetFilters: () => void;
}

export const useSendersStore = create<SendersState>(set => ({
  // Initial state
  searchQuery: '',
  statusFilter: 'all',
  selectedSenderUuid: null,
  isCreateModalOpen: false,
  isEditModalOpen: false,
  isValidationModalOpen: false,
  isConfigurationModalOpen: false,
  isDeleteModalOpen: false,

  // Actions
  setSearchQuery: query => set({ searchQuery: query }),
  setStatusFilter: filter => set({ statusFilter: filter }),
  setSelectedSender: uuid => set({ selectedSenderUuid: uuid }),

  openCreateModal: () => set({ isCreateModalOpen: true }),
  closeCreateModal: () => set({ isCreateModalOpen: false }),

  openEditModal: uuid =>
    set({
      isEditModalOpen: true,
      selectedSenderUuid: uuid,
    }),
  closeEditModal: () =>
    set({
      isEditModalOpen: false,
      selectedSenderUuid: null,
    }),

  openValidationModal: uuid =>
    set({
      isValidationModalOpen: true,
      selectedSenderUuid: uuid,
    }),
  closeValidationModal: () =>
    set({
      isValidationModalOpen: false,
      selectedSenderUuid: null,
    }),

  openConfigurationModal: uuid =>
    set({
      isConfigurationModalOpen: true,
      selectedSenderUuid: uuid,
    }),
  closeConfigurationModal: () =>
    set({
      isConfigurationModalOpen: false,
      selectedSenderUuid: null,
    }),

  openDeleteModal: uuid =>
    set({
      isDeleteModalOpen: true,
      selectedSenderUuid: uuid,
    }),
  closeDeleteModal: () =>
    set({
      isDeleteModalOpen: false,
      selectedSenderUuid: null,
    }),

  resetFilters: () =>
    set({
      searchQuery: '',
      statusFilter: 'all',
    }),
}));
